/* eslint-disable */
// @ts-nocheck
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { BORDER_RADIUS_SM } from "../../theme/theme";

export default function DeleteOrgDialog({
  deleteOrgConfirmOpen,
  cancelDeleteOrganisation,
  deleteOrgName,
  deleteOrgConfirmText,
  setDeleteOrgConfirmText,
  confirmDeleteOrganisation,
}: any) {
  return (
    <Dialog
      open={deleteOrgConfirmOpen}
      onClose={cancelDeleteOrganisation}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ color: "error.main", fontWeight: "bold" }}>
        Delete Organization - DANGEROUS ACTION
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          You are about to permanently delete the organization:
        </DialogContentText>
        <DialogContentText
          sx={{ fontWeight: "bold", mb: 2, p: 1, bgcolor: "grey.100", borderRadius: BORDER_RADIUS_SM }}
        >
          "{deleteOrgName}"
        </DialogContentText>
        <DialogContentText sx={{ mb: 2, color: "error.main" }}>
          WARNING: This action cannot be undone and will permanently remove:
        </DialogContentText>
        <DialogContentText component="div" sx={{ mb: 3 }}>
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            <li>All users associated with this organization</li>
            <li>All meetings and records</li>
            <li>All configurations and settings</li>
          </ul>
        </DialogContentText>
        <DialogContentText sx={{ mb: 2, fontWeight: "bold" }}>
          To confirm, type the organization name in FULL CAPS:
        </DialogContentText>
        <TextField
          fullWidth
          label={`Type "${deleteOrgName?.toUpperCase()}" to confirm`}
          value={deleteOrgConfirmText}
          onChange={(e) => setDeleteOrgConfirmText(e.target.value)}
          variant="outlined"
          placeholder={deleteOrgName?.toUpperCase()}
          sx={{ mt: 1 }}
          autoFocus
        />
        {deleteOrgConfirmText && deleteOrgConfirmText !== deleteOrgName?.toUpperCase() && (
          <DialogContentText sx={{ color: "error.main", mt: 1, fontSize: "0.875rem" }}>
            Please type the exact organization name in capital letters
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={cancelDeleteOrganisation} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={confirmDeleteOrganisation}
          color="error"
          variant="contained"
          disabled={deleteOrgConfirmText !== deleteOrgName?.toUpperCase()}
          startIcon={<Delete />}
        >
          Confirm delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
